import { createContext, useContext } from 'react'

export type RuleCardPath = 'earn' | 'redemption' | 'bonus_points'

// Outcome of a per-card save. On failure, `error` carries a client-facing
// message lifted from the API response so the card can surface it inline.
export interface SaveCardResult {
  ok: boolean
  error?: string
}

export interface RuleCardActions {
  // Persist a single card. The API is atomic (full document), so the body is the
  // last-saved baseline of every other card with only `cardPath` replaced by its
  // current form values — in-progress edits in other open cards are NOT saved.
  // `enableOverride` carries a just-flipped enable toggle whose Formik state
  // hasn't settled yet. Resolves to `{ ok }`, plus an `error` message when the
  // save fails (validation block or API error).
  saveCard: (
    cardPath: RuleCardPath,
    enableOverride?: boolean,
  ) => Promise<SaveCardResult>
  isSaving: boolean
}

export const RuleCardActionsContext = createContext<RuleCardActions>({
  saveCard: async () => ({ ok: false }),
  isSaving: false,
})

export const useRuleCardActions = (): RuleCardActions =>
  useContext(RuleCardActionsContext)
